import styled from "styled-components";
import { COMMON } from "@sproutsocial/seeds-react-system-props";

const Container = styled.table`
  width: 100%;
  border-collapse: collapse;

  thead {
    vertical-align: bottom;
  }

  tr,
  thead {
    border-bottom: 1px solid
      ${(props) => props.theme.colors.container.border.base};
  }

  ${COMMON}
`;

export default Container;
